/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_minecraft_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked Mojang Account`)
};

const zh_hans1_settings_minecraft_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已绑定的 Mojang 账号`)
};

const zh_hant1_settings_minecraft_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已綁定的 Mojang 帳號`)
};

const fr_settings_minecraft_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte Mojang lié`)
};

const de_settings_minecraft_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpftes Mojang-Konto`)
};

const ja_settings_minecraft_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携済み Mojang アカウント`)
};

const ko_settings_minecraft_linked = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연동된 Mojang 계정`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_minecraft_linked = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_minecraft_linked(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_minecraft_linked", locale)
	if (locale === "en") return en_settings_minecraft_linked(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_minecraft_linked(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_minecraft_linked(inputs)
	if (locale === "fr") return fr_settings_minecraft_linked(inputs)
	if (locale === "de") return de_settings_minecraft_linked(inputs)
	if (locale === "ja") return ja_settings_minecraft_linked(inputs)
	return ko_settings_minecraft_linked(inputs)
};